<template>
  <!-- End of website notice -->
  <!-- <div class="text-center mb-6 z-10">
    <p class="text-sm font-medium text-gray-700 mb-3">Dosiahli ste koniec stránky. Tu už nič nie je.</p>
    <button @click="scrollToTop"
      class="inline-flex items-center px-4 py-2 bg-red-600 text-white rounded-full hover:bg-red-700 transition-colors text-sm font-medium">
      <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 10l7-7m0 0l7 7m-7-7v18"></path>
      </svg>
      Späť hore
    </button>
  </div> -->
  <footer class="relative text-gray-600 pt-12 pb-6 px-6 md:px-16 lg:px-16 xl:px-24">

    <!-- Background image -->
    <img src="@/assets/images/bg-auth2.jpg" alt="Footer background"
      class="absolute inset-0 w-full h-full object-cover brightness-50">

    <!-- Shadow overlay with gradient transition from top -->
    <div
      class="absolute inset-0 bg-gradient-to-b from-white/70 via-white/50 to-white/40 shadow-[0_-10px_30px_rgba(0,0,0,0.1)]">
    </div>

    <!-- Content on top -->
    <div class="max-w-6xl mx-auto relative z-10">
      <!-- Brand Section -->
      <div class="text-center mb-10">
        <img src="@brand/assets/logo_underline.png" :alt="$brand.siteName" class="mx-auto mb-4 h-12 md:h-16">
        <p class="text-lg md:text-xl font-semibold text-gray-800 mb-6">
          Nakúp viac, zaplať menej.
        </p>
        <div class="flex items-center justify-center gap-5">
          <a href="https://www.facebook.com/share/1GPNJyUof2/" target="_blank" rel="noopener noreferrer"
            class="text-gray-500 hover:text-[#ac2e0b] transition-all duration-300 hover:scale-110">
            <FacebookIcon :size="28" />
          </a>
        </div>
      </div>

      <!-- Links Section -->
      <div class="flex flex-wrap justify-center gap-x-8 gap-y-2 mb-10 text-sm">
        <router-link :to="$pagePath('contact')" class="hover:text-[#ac2e0b] transition-colors">Kontakt</router-link>
        <router-link v-if="$hasFeature('b2b')" :to="$pagePath('b2b')" class="hover:text-[#ac2e0b] transition-colors">B2B Program</router-link>
        <router-link :to="$pagePath('terms')" class="hover:text-[#ac2e0b] transition-colors">Informácie o
          doprave</router-link>
        <router-link :to="$pagePath('terms')" class="hover:text-[#ac2e0b] transition-colors">Obchodné
          podmienky</router-link>
        <router-link :to="$pagePath('returns')" class="hover:text-[#ac2e0b] transition-colors">Reklamačný
          poriadok</router-link>
      </div>

      <!-- Bottom Section -->
      <div class="border-t border-gray-300 pt-6">
        <div class="text-center text-xs text-white">
          <p> {{ new Date().getFullYear() }} {{ $brand.siteName }}. Takmer všetky práva vyhradené. <br><small
              class="text-gray-100/10">Aspoň nemáme predajňu na kúpalisku a AI vygenerovanú stránku 😘</small></p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { ref, computed } from 'vue'
import {
  FacebookIcon,
  InstagramIcon,
} from 'lucide-vue-next'

// Reactive data
const newsletterEmail = ref('')
const isSubscribing = ref(false)

// Computed properties
const currentYear = computed(() => new Date().getFullYear())

// Newsletter subscription
const scrollToTop = () => {
  if (typeof window !== 'undefined') {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}

const subscribeNewsletter = async () => {
  if (!newsletterEmail.value.trim()) return

  isSubscribing.value = true

  try {
    // TODO: Implement newsletter subscription API call
    await new Promise(resolve => setTimeout(resolve, 1000)) // Simulate API call

    // Show success message (you can use a toast notification here)
    alert('Ďakujeme za prihlásenie k odberu noviniek!')
    newsletterEmail.value = ''
  } catch (error) {
    console.error('Newsletter subscription error:', error)
    alert('Nastala chyba pri prihlasovaní. Skúste to prosím znovu.')
  } finally {
    isSubscribing.value = false
  }
}
</script>